import {
    GetAccountsResponse,
    GetApplicationResponse
} from '@iwoca/lapi-client/edge';
import { mergeStates } from '../../iwProvider/StoreHelper';
import { NAVIGATION_READY } from './Navigation.actions';
import {
    getDefaultDashboardLocation,
    hasIwocaPayApplication,
    hasValidIwocaPayFormalOffer
} from '../dashboard/getDefaultDashboardLocation';
import { MY_OFFERS_URL } from '../myOffers/MyOffers.sagas';
import { isFlexi24Duration } from '../flexi24/getIsFlexi24Duration';

type NavigationAction = {
    type: typeof NAVIGATION_READY;
    accountsResponse: GetAccountsResponse;
    applicationResponse: GetApplicationResponse;
};

type NavigationState = {
    ready: boolean;
    showRBL: boolean;
    showIwocaPay: boolean;
    showTermLoan: boolean;
    showRLS: boolean;
    showCBILS: boolean;
    showSecondCBILS: boolean;
    showFlexiLoan: boolean;
    showFlexi24: boolean;
    showMyOffers: boolean;
};

const initialState: NavigationState = {
    ready: false,
    showRBL: false,
    showIwocaPay: false,
    showTermLoan: false,
    showRLS: false,
    showCBILS: false,
    showSecondCBILS: false,
    showFlexiLoan: false,
    showFlexi24: false,
    showMyOffers: false
};

// eslint-disable-next-line import/no-default-export
export default function (
    state = mergeStates(initialState),
    action: NavigationAction
): NavigationState {
    switch (action.type) {
        case NAVIGATION_READY: {
            const { accountsResponse, applicationResponse } = action;

            let shouldShowMyOffers = true;

            const hasIwocaPayApplicationOrFormalOffer =
                hasIwocaPayApplication(applicationResponse) ||
                hasValidIwocaPayFormalOffer(accountsResponse);

            const defaultLocation = getDefaultDashboardLocation(
                applicationResponse,
                accountsResponse
            );
            shouldShowMyOffers = defaultLocation?.pathname === MY_OFFERS_URL;

            const accountsProductTypes =
                getAccountsProductTypes(accountsResponse);

            return mergeStates(state, {
                ready: true,
                showRBL:
                    accountsProductTypes.includes('merchant_cash_advance') &&
                    !shouldShowMyOffers,
                showIwocaPay:
                    accountsProductTypes.includes('iwocapay') ||
                    hasIwocaPayApplicationOrFormalOffer,
                showTermLoan: accountsProductTypes.includes('term_loan'),
                showRLS: accountsProductTypes.includes('recovery_loan'),
                showCBILS: accountsProductTypes.includes('cbils'),
                showSecondCBILS:
                    accountsProductTypes.filter(
                        (productType) => productType === 'cbils'
                    ).length === 2,
                showFlexiLoan:
                    accountsProductTypes.includes('credit_facility') &&
                    !shouldShowMyOffers,
                showFlexi24:
                    accountsProductTypes.includes('flexi24') &&
                    !shouldShowMyOffers,
                showMyOffers:
                    shouldShowMyOffers ||
                    (accountsProductTypes.includes('iwocapay') &&
                        !accountsProductTypes.includes('credit_facility') &&
                        !accountsProductTypes.includes('flexi24'))
            });
        }

        default:
            return state;
    }
}

const getAccountsProductTypes = (accountsResponse: GetAccountsResponse) => {
    const productTypes = [];

    for (const account of accountsResponse.data!.accounts) {
        if (!account.product_type || !account.account_id) continue;
        if (
            account.product_type === 'credit_facility' &&
            isFlexi24Duration(account.duration!)
        ) {
            productTypes.push('flexi24');
        } else {
            productTypes.push(account.product_type);
        }
    }

    return productTypes;
};
